export default __webpack_public_path__ + "static/media/shield2.c4ecb56b.png";